import { Select } from "@aclymatepackages/atoms";

// These 4 values must stay exactly this camelCase -- @aclymatepackages/calcs
// matches gas units case-sensitively, and a miscased value here would flow
// straight into a transaction's stored emissionData.gasUnit, silently
// undercounting emissions 35x-1000x. Exported so a regression (a typo, an
// accidental lowercase) is caught by test_GasUnitSelect.js, not discovered
// in production data.
export const GAS_UNIT_OPTIONS = [
  { label: "Therms", value: "therms" },
  { label: "Mcf", value: "mcf" },
  { label: "Ccf", value: "ccf" },
  { label: "Cubic Meters", value: "cubicMeters" },
];

const GasUnitSelect = ({ label = "Select Units", gasUnit, editGasUnit }) => {
  return (
    <Select
      options={GAS_UNIT_OPTIONS}
      size="small"
      label={label}
      value={gasUnit}
      editValue={editGasUnit}
    />
  );
};
export default GasUnitSelect;
